<button class="btn btn-success btn-block btn-lg" (click)="modalCodigoManual()">
  CODIGO MANUAL
</button>

<!-- Modal remesas-->
<div
  class="modal fade"
  id="modalCodigoManual"
  tabindex="-1"
  role="dialog"
  aria-labelledby="modelTitleId"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-producto-contenido">
        <form [formGroup]="barraForm" class="flex center-center mb-1">
          <input
            id="barra"
            type="text"
            formControlName="barra"
            class="input-producto-qty"
            (keyup.enter)="enviarCodigo()"
          />
        </form>

        <div class="row-numeros">
          <button class="btn-numero" (click)="agregarDigito('7')">7</button>
          <button class="btn-numero" (click)="agregarDigito('8')">8</button>
          <button class="btn-numero" (click)="agregarDigito('9')">9</button>
        </div>

        <div class="row-numeros">
          <button class="btn-numero" (click)="agregarDigito('4')">4</button>
          <button class="btn-numero" (click)="agregarDigito('5')">5</button>
          <button class="btn-numero" (click)="agregarDigito('6')">6</button>
        </div>

        <div class="row-numeros">
          <button class="btn-numero" (click)="agregarDigito('1')">1</button>
          <button class="btn-numero" (click)="agregarDigito('2')">2</button>
          <button class="btn-numero" (click)="agregarDigito('3')">3</button>
        </div>

        <div class="row-numeros">
          <button class="btn-numero" (click)="agregarDigito('0')">0</button>
          <button class="btn-numero" (click)="agregarDigito('*')">*</button>
          <button class="btn-numero" (click)="borrarDigito()">
            <i class="fas fa-backspace"></i>
          </button>
        </div>

        <div class="seccion-botones">
          <button class="btn-aceptar" (click)="enviarCodigo()">ACEPTAR</button>
          <button class="btn-eliminar" (click)="cerrarModal()">CANCELAR</button>
        </div>
      </div>
    </div>
  </div>
</div>
